export default __webpack_public_path__ + "334b2e5410f218fb7107793c71e049b0.png";